export default "__VITE_ASSET__CbJZVDbl__"